const organisationId = (state) => state.organisationId
const organisation = (state) => state.organisation

export default {
  organisationId,
  organisation
}
